export const URL_POST_LOGIN = `${process.env.REACT_APP_API_URL}/token`
export const URL_GET_USER = `${process.env.REACT_APP_API_URL}/current/user.json`
